import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import UnauthenticatedPage from "../../containers/UnantheticatedPage";
import Login from "../../pages/Login";
import SidebarLayout from "../layout/SidebarLayout";
import { FooterProvider } from "../layout/FooterContext";
import { useMsal } from '@azure/msal-react';
import BasicLogin from "../auth/BasicLogin";


export const ProtectedEntryPoint = () => {
  // const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const basicEnabled = process.env.REACT_APP_ENABLE_BASIC_LOGIN === "true";
  const basicLoggedIn = typeof window !== "undefined" && !!localStorage.getItem("basicAuthUser");

  if (accounts.length > 0 || (basicEnabled && basicLoggedIn)) {
    return (
      <FooterProvider>
        <SidebarLayout />
      </FooterProvider>
    );
  }

  if (basicEnabled) {
    return <BasicLogin />;
  }

  return <Login />;
};
